<template>
  <div class="bg-ip-color-6 relative">
    <div :class="route.name !== 'index' && route.name !== 'index___en'? 'absolute':'absolute md:fixed hidden md:block'" class="bottom-24 md:bottom-16 left-3 md:left-auto md:right-8 width-[237px] rounded-[10px] z-10 bg-white bg-opacity-50 backdrop-blur-sm shadow-md shadow-gray-300/25">
      <Badge></Badge>
    </div>
    <div class="text-white relative overflow-clip mx-auto">
      <div class="container-1 space-y-14 relative z-2">
        <div class="py-11 flex flex-col-reverse lg:grid lg:grid-cols-2 gap-10 lg:gap-0">
          <div class="space-y-4">
            <NuxtLink :to="({name: 'index'})" class="inline-block max-w-[9rem] lg:max-w-[12vw]"><MainLogo color="white"/></NuxtLink>
            <a href="https://maps.app.goo.gl/oEUXhDVi7Xuv7Mti9" target="_blank" class="block figtree max-w-[26rem] text-[4vw] md:text-[1.4vw] lg:text-[1vw] lg:max-w-[24vw]">
              PT. KANITA BUMI LESTARI <br>
              Gedung Office 8, Level 18-A. Jl. Senopati No. 8B, <br>
              Kawasan SCBD Kel. Senayan, Kec. Kebayoran Baru, <br>
              Jakarta Selatan 12190
            </a>
            <div class="space-y-3">
              <!-- <div>
                <a target="_blank" class="flex gap-2 items-center lg:hidden relative w-full h-full" href="tel:+622122773278">
                  <Icon class="w-6 h-6 lg:w-[1.3vw] lg:h-[1.3vw]" name="mdi:phone"/>
                  <div class="figtree lg:text-[1vw]">{{ copyTextLang.phone }}</div>
                </a>
                <div @click="copyToClipboard('phone', '+622122773278')" class="hidden lg:flex gap-2 items-center cursor-pointer">
                  <Icon class="w-6 h-6 lg:w-[1.3vw] lg:h-[1.3vw]" name="mdi:phone"/>
                  <div class="figtree lg:text-[1vw]">{{ copyTextLang.phone }}</div>
                </div>
              </div> -->
              <a href="https://linkedin.com/in/impacthink-indonesia-8561a62b0" class="flex gap-1 items-center"><Icon class="w-6 h-6 lg:w-[1.3vw] lg:h-[1.3vw]" name="formkit:linkedin"/><span class="figtree text-base lg:text-[1vw] mt-[0.5%]">ImpacThink Indonesia</span></a>
              <div @click="copyToClipboard('email', 'hello@impacthink.id')" class="flex gap-2 items-center cursor-pointer">
                <Icon class="w-6 h-6 lg:w-[1.3vw] lg:h-[1.3vw]" name="fluent:mail-32-filled"/>
                <span class="figtree lg:text-[1vw]">{{ copyTextLang.email }}</span>
              </div>
              <a href="https://www.instagram.com/impacthink.id/" target="_blank" class="flex gap-1 items-center"><Icon class="w-6 h-6 lg:w-[1.3vw] lg:h-[1.3vw]" name="mdi:instagram"/><span class="figtree text-base lg:text-[1vw]">@impacthink.id</span></a>
            </div>
          </div>
          <div class="space-y-4">
            <div class="figtree font-bold text-2xl lg:text-[1.2vw]">About Us</div>
            <div class="space-y-3">
              <div v-for="item in footerMenus" :key="item">
                <NuxtLink v-if="item.type == 'link'" :to="({name: item.path})" class="block figtree relative w-fit overflow-clip group pb-1 lg:text-[1vw]">
                  {{ item.name[lang] }}
                  <div class="absolute w-full border-t-2 border-white bottom-0 -translate-x-[102%] group-hover:translate-x-0 transition-transform duration-300"></div>
                </NuxtLink>
                <button v-else @click="item.function()" class="block figtree relative w-fit overflow-clip group pb-1 lg:text-[1vw]">
                  {{ item.name[lang] }}
                  <div class="absolute w-full border-t-2 border-white bottom-0 -translate-x-[102%] group-hover:translate-x-0 transition-transform duration-300"></div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between px-4 lg:px-0 py-7 lg:py-6">
          <!-- <div class=" flex gap-10">
            <a href="https://www.instagram.com/impacthink.id/" target="_blank" class="hidden lg:flex gap-1 items-center"><Icon class="w-6 h-6 lg:w-[1.3vw] lg:h-[1.3vw]" name="mdi:instagram"/><div class="figtree text-base lg:text-[1vw]">@impacthink.id</div></a>
            <a href="https://linkedin.com/in/impacthink-indonesia-8561a62b0" target="_blank" class="hidden lg:flex gap-1 items-center"><Icon class="w-6 h-6 lg:w-[1.3vw] lg:h-[1.3vw]" name="formkit:linkedin"/><div class="figtree text-base lg:text-[1vw]">impacthink Indonesia</div></a>
          </div> -->
          <div class="figtree text-base text-center lg:text-left lg:text-[1vw]">Copyright © {{ new Date().getFullYear() }} ImpacThink - PT. Kanita Bumi Lestari</div>
        </div>
      </div>

      <div class="absolute bottom-20 top-auto lg:top-10 right-5 opacity-20">
        <VectorSingleArrow color="ip-color-3"/>
      </div>
    </div>
  </div>
</template>

<script setup>
 

 
 
const lang = ref('en')
const navbarStore = useNavbarStore();
const route = useRoute();
const footerMenus = ref([
  {
    path: 'index',
    sort: 0,
    visible: true,
    name: {
      id: 'Home',
      en: 'Home',
    },
    type: 'link',
  },
  {
    path: 'about-us',
    sort: 1,
    visible: true,
    name: {
      id: 'About Us',
      en: 'About Us',
    },
    type: 'link',
  },
  {
    path: 'our-services',
    sort: 2,
    visible: true,
    name: {
      id: 'Our Services',
      en: 'Our Services',
    },
    type: 'link',
  },
  {
    path: 'insights',
    sort: 3,
    visible: true,
    name: {
      id: 'Insights',
      en: 'Insights',
    },
    type: 'link',
  },
  {
    path: 'contact-us',
    sort: 4,
    visible: true,
    name: {
      id: 'Contact Us',
      en: 'Contact Us',
    },
    type: 'button',
    function: () => {
      navbarStore.toggleContact();
    },
  },
]);

const copyTextLang = ref({
  email: 'hello@impacthink.id',
  phone: '+62 21 22773278',
});

const resetCopyTextLang = ref({
  email: 'hello@impacthink.id',
  phone: '+62 21 22773278',
});

const copyToClipboard = (name, text) => {
  navigator.clipboard.writeText(text).then(function () {
    copyTextLang.value[name] = 'Copied to Clipboard';
    const to = setTimeout(() => {
      copyTextLang.value[name] = resetCopyTextLang.value[name];
      clearTimeout(to);
    }, 3000);
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });
};
const timeout = ref(null);

onMounted(() => {
  if (process.client) {
    timeout.value = setTimeout(() => {
      const wcb = document.querySelector('#wcb').outerHTML;
      navbarStore.setCarbonBadge(wcb);
    }, 1000);
  };
});

</script>

<style lang="scss" scoped>
// .bg-gradient-footer{
//   background: rgb(38,79,108);
//   background: linear-gradient(10deg, rgba(38,79,108,1) 0%, rgba(47,144,212,1) 100%);
// }

</style>
